import { render } from "./SettingsLanguagesAddModal.vue?vue&type=template&id=4076f93e&scoped=true&ts=true"
import script from "./SettingsLanguagesAddModal.vue?vue&type=script&lang=ts"
export * from "./SettingsLanguagesAddModal.vue?vue&type=script&lang=ts"

import "./SettingsLanguagesAddModal.vue?vue&type=style&index=0&id=4076f93e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4076f93e"]])

export default __exports__